<template>
  <div
    class="bg-white border border-white-kft rounded-lg shadow-sm flex md:grid md:grid-cols-2 text-sm md:text-md flex-wrap bg-[#f5f5f5] w-100 p-8 gap-10"
  >
    <div
      v-for="(items, i) in iconHeadingList"
      :key="`index_item_${i}`"
      class="flex gap-8"
      :class="{
        grid: items.length > 1,
        flex: items.length < 2,
        'grid-cols-2': items.length > 1,
      }"
    >
      <div
        v-for="(item, i2) in items"
        :key="`second_row_${i2}`"
        class="flex gap-2 [&>svg]:flex-shrink-0"
      >
        <component :is="item.iconComp" class="mt-[2px]" />
        <Heading
          :level="2"
          :title="item.label"
          :description="item.description"
          class="flex-column w-100 kft-heading--left"
          h-class="text-h6"
        />
      </div>
    </div>
  </div>
</template>

<script lang="ts" setup>
export interface IconHeadingItem {
  iconComp: ComponentPublicInstance
  label: string
  description: string
}

defineProps<{
  iconHeadingList: []
}>()
</script>
